import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class SignUpUnsupportedLocationError extends CodedError {
  static get errorName() {
    return errorCodes.signUpUnsupportedLocationError.code;
  }

  constructor(message: string = errorCodes.signUpUnsupportedLocationError.message) {
    super(message);
    this.code = errorCodes.signUpUnsupportedLocationError.code;
    this.message = `${message} ${errorCodes.signUpUnsupportedLocationError.code}`;
    this.name = errorCodes.signUpUnsupportedLocationError.name;
  }
}
